import { create } from 'zustand';

export interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'aion';
  timestamp: Date;
}

interface ChatState {
  isOpen: boolean;
  isTyping: boolean;
  messages: ChatMessage[];
  setIsOpen: (open: boolean) => void;
  setIsTyping: (typing: boolean) => void;
  addMessage: (message: ChatMessage) => void;
  resetMessages: (messages?: ChatMessage[]) => void;
}

const initialMessages: ChatMessage[] = [
  {
    id: '1',
    text: 'Hola, soy AION Assistant, el copiloto inteligente de la plataforma.\n\nEstoy aquí para guiarte paso a paso mientras usás el sistema. Decime en qué parte estás o qué estás tratando de hacer y te ayudo.',
    sender: 'aion',
    timestamp: new Date(),
  },
];

export const useChatStore = create<ChatState>((set) => ({
  isOpen: false,
  isTyping: false,
  messages: initialMessages,
  setIsOpen: (open) => set({ isOpen: open }),
  setIsTyping: (isTyping) => set({ isTyping }),
  addMessage: (message) => set((state) => ({ messages: [...state.messages, message] })),
  resetMessages: (messages = initialMessages) => set({ messages }),
}));
